<ngx-loading [show]="loading"></ngx-loading>
<div *ngIf="documentPassword">
  <ngx-extended-pdf-viewer
    [src]="documentSrc"
    useBrowserLocale="true"
    [password]="documentPassword"
    [height]="'100vh'"
    [showOpenFileButton]="false"
    [showBookmarkButton]="false"
    [showScrollingButton]="false"
    [showSpreadButton]="false"
    [showPropertiesButton]="false"
    [showUnverifiedSignatures]="true"
    [enablePinchOnMobile]="true"
    backgroundColor="#d7d3d9"
  >
  </ngx-extended-pdf-viewer>
</div>

<ng-template #passwordModal>
  <div class="modal-body password-modal">
    <div class="row mb-1">
      <div class="col-12">
        {{ 'document.passwordLabel' | translate }}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <input class="form-control form-control-sm" type="password" autocomplete="off" #password required />
      </div>
    </div>
    <div class="row text-right mt-1">
      <div class="col-12">
        <button class="btn btn-primary btn-sm" [disabled]="!password.value" (click)="submitPassword(password.value)">submit</button>
      </div>
    </div>
  </div>
</ng-template>
